import { render } from "./Badge.vue?vue&type=template&id=21176872&scoped=true"
import script from "./Badge.vue?vue&type=script&lang=js"
export * from "./Badge.vue?vue&type=script&lang=js"

import "./Badge.vue?vue&type=style&index=0&id=21176872&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21176872"]])

export default __exports__